import callAPiBase from './base';

const transportCardsApi = {
  get: ({ params }: { params: object }) =>
    callAPiBase({
      endpoint: '/transportCardList',
      method: 'GET',
      useToken: true,
      title: 'Transport Cards - Get List',
      params,
    }),
  create: ({ data }: { data: object }) =>
    callAPiBase({
      endpoint: '/transportCardCreate',
      method: 'POST',
      useToken: true,
      title: 'Transport Cards - Create Card',
      data,
    }),
  createList: ({ data }: { data: object }) =>
    callAPiBase({
      endpoint: '/transportCardCreateList',
      method: 'POST',
      useToken: true,
      title: 'Transport Cards - Create List',
      data,
    }),
  update: ({ data }: { data: object }) =>
    callAPiBase({
      endpoint: '/transportCardUpdate',
      method: 'PUT',
      useToken: true,
      title: 'Transport Cards - Update',
      data,
    }),
  delete: ({ params }: { params: object }) =>
    callAPiBase({
      endpoint: '/transportCardDelete',
      method: 'DELETE',
      useToken: true,
      title: 'Transport Cards - Delete',
      params,
    }),
  requestCard: ({ data }: { data: object }) =>
    callAPiBase({
      endpoint: '/transportCardRequest',
      method: 'POST',
      useToken: true,
      title: 'Transport Cards - Request Card',
      data,
    }),
  activateCard: ({ data }: { data: object }) =>
    callAPiBase({
      endpoint: '/transportCardActivate',
      method: 'POST',
      useToken: true,
      title: 'Transport Cards - Activate Card',
      data,
    }),
  deviceActivate: ({ data }: { data: object }) =>
    callAPiBase({
      endpoint: '/transportCardCreateFromDevice ',
      method: 'POST',
      useToken: true,
      title: 'Transport Cards - Activate Device',
      data,
    }),
  getTransportCardSettings: ({ params }: { params: object }) =>
    callAPiBase({
      endpoint: '/transportCardSettingsGet',
      method: 'GET',
      useToken: true,
      title: 'Transport Cards - Settings',
      params,
    }),
  updateTransportCardSettings: ({ data }: { data: object }) =>
    callAPiBase({
      endpoint: '/transportCardSettingsUpdate',
      method: 'PUT',
      useToken: true,
      title: 'Transport Cards - settings',
      data,
    }),
};

export { transportCardsApi };
export default transportCardsApi;
